export default __webpack_public_path__ + "static/media/81ede6bd95cb206c09cd00489bfe12eb.0a2daf70.png";